import { generateUrlParams } from "../../utils/generateUrlParams";

const baseUrl = "OLevel";

export const loadOlevelDetailsUrl = (applicationTypeId, applicantId) =>
	`${baseUrl}/get-olevel-details?ApplicationTypeId=${applicationTypeId}&ApplicantId=${applicantId}`;

//post
export const updateOlevelUrl = () =>
	`${baseUrl}/add-or-update-verify-olevel-details`;

export const getOLevelVerificationReportsUrl = (filter) =>
	`${baseUrl}/get-olevel-verification-reports?${generateUrlParams(filter)}`;

export const downloadOLevelVerificationReportUrl = (filter) =>
	`${baseUrl}/download-olevel-verification-report?${generateUrlParams(filter)}`;

export const getOLevelVerificationReportDetailsUrl = (id) =>
	`${baseUrl}/get-olevel-verification-report-details/${id}`;
